module.exports = __webpack_public_path__ + "static/media/document-sent-confirmation.0ac53a5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/document-sent-confirmation.png
// module id = 292
// module chunks = 17